import type { AgentExecutionDto } from '@terra/shared-contracts-agent-execution';
import { getAiDiscoveryMetadata } from './discovery.utils';

export type AiDiscoveryStatusBarFilter =
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED'
  | 'STOPPED';

export type AiDiscoveryStatusBarCounts = Record<
  AiDiscoveryStatusBarFilter,
  number
>;

const EMPTY_AI_DISCOVERY_STATUS_BAR_COUNTS: AiDiscoveryStatusBarCounts = {
  IN_PROGRESS: 0,
  COMPLETED: 0,
  FAILED: 0,
  STOPPED: 0,
};

export function resolveAiDiscoveryFilterStatus(
  execution: AgentExecutionDto,
): AgentExecutionDto['status'] {
  const status = execution.status;

  if (status === 'ABORTED') {
    return 'ABORTED';
  }

  const verdictStatus = getAiDiscoveryMetadata(
    execution.metadata,
  )?.verdictStatus;

  if (verdictStatus === 'FAILED') {
    return 'FAILED';
  }

  return status;
}

export function resolveAiDiscoveryStatusBarBucket(
  execution: AgentExecutionDto,
): AiDiscoveryStatusBarFilter {
  const status = resolveAiDiscoveryFilterStatus(execution);

  if (status === 'PENDING' || status === 'RUNNING') {
    return 'IN_PROGRESS';
  }

  if (status === 'FAILED' || status === 'BLOCKED') {
    return 'FAILED';
  }

  if (status === 'COMPLETED') {
    return 'COMPLETED';
  }

  return 'STOPPED';
}

export function computeAiDiscoveryStatusBarCounts(
  executions: AgentExecutionDto[],
): AiDiscoveryStatusBarCounts {
  return executions.reduce<AiDiscoveryStatusBarCounts>(
    (counts, execution) => {
      const bucket = resolveAiDiscoveryStatusBarBucket(execution);

      counts[bucket] += 1;

      return counts;
    },
    { ...EMPTY_AI_DISCOVERY_STATUS_BAR_COUNTS },
  );
}
